export default{
  goodsList:{
    breadcrumb:{
      home:"Home",
      all:"All Products"
    },
    filter:{
      catgTit:"Categories",
      brandTit:"Brands",
      button:{
        open:"More",
        close:"Collapse"
      },
      noFilter:"All"
    },
    sort:{
      default:"Default",
      price:"Price",
      count:"Sales",
      update:"Updated"
    },
    total:{
      head:"Total",
      tail:"products found"
    },
    Table:{
      productName:"Product Info",
      goToshop:"Visit Store",
      firstSkuName:"Specifications",
      dayOutput:"Daily Supply",
      price:"Unit Price",
      egotiable:"Negotiable",
      reight:"Shipping Negotiable",
      money:"¥",
      opert:"Action"
    },
    Button:{
      getDetails:"View Details",
      car:"Add to Cart",
      soldOut:"Sold Out"
    },
    Download:{
      end:'End of List'
    },
    Confirm:{
      title:"Notification",
      content:"Item added to cart",
      confirmButtonText:"Checkout",
      cancelButtonText:"Continue Shopping"
    }
  }
}